import { useEffect } from "react";

// Paints every match of `query` inside `ref` with the CSS Custom Highlight API (no DOM rewrites).
// Style lives in index.css under ::highlight(frs-search). Only table / tree content is painted —
// toolbars, pills and inputs are skipped. `terms` is a list of phrases (matched case-insensitively).
export default function useTextHighlight(ref, terms, name = "frs-search") {
  const key = (terms || []).join("\u0001");
  useEffect(() => {
    const reg = typeof CSS !== "undefined" && CSS.highlights;
    const root = ref.current;
    if (!reg || !root) return undefined;
    const list = key ? key.split("\u0001").map((t) => t.toLowerCase()) : [];
    if (!list.length) { reg.delete(name); return undefined; }
    let raf = 0;
    const paint = () => {
      const ranges = [];
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: (n) => {
          const el = n.parentElement;
          if (!el || el.closest("input, textarea, [data-no-highlight]") || !el.closest("tbody, [data-highlight-scope]")) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        },
      });
      for (let n = walker.nextNode(); n; n = walker.nextNode()) {
        const text = n.nodeValue.toLowerCase();
        for (const t of list) {
          for (let i = text.indexOf(t); i !== -1; i = text.indexOf(t, i + t.length)) {
            const r = new Range(); r.setStart(n, i); r.setEnd(n, i + t.length); ranges.push(r);
          }
        }
      }
      reg.set(name, new Highlight(...ranges));
    };
    paint();
    const mo = new MutationObserver(() => { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
    return () => { mo.disconnect(); cancelAnimationFrame(raf); reg.delete(name); };
  }, [ref, key, name]);
}
